import { render, staticRenderFns } from "./Datareport.vue?vue&type=template&id=58f1edd8&scoped=true"
import script from "./Datareport.vue?vue&type=script&lang=js"
export * from "./Datareport.vue?vue&type=script&lang=js"
import style0 from "./Datareport.vue?vue&type=style&index=0&id=58f1edd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1edd8",
  null
  
)

export default component.exports